export enum CheckBoxStatus {
  UNCHECKED,
  CHECKED,
  ALL_CHILDREN_ARE_CHECKED,
  PARTIALLY_CHECKED
}

export type CheckBoxProps = {
  onClick: () => void
  checked?: boolean
  label?: string
  className?: string
  status: CheckBoxStatus
}
